import { Map } from 'immutable';

import {
    Action,
    ReceiveJobSearches,
    ReceiveJobSearchStats,
    ReceivePurgeCandidatesResponse,
    RequestSearchDelete
} from '../actions';
import { JobSearchesState } from '../state';

const initialState: Map<string, JobSearchesState> = null;

export function searches(state = initialState, action: Action): Map<string, JobSearchesState> {
    switch (action.type) {
        case ReceiveJobSearches:
        case ReceiveJobSearchStats: {
            const stateVal = (state || Map()).get(action.payload.jobId);
            const searchStats = action.payload.data.searchStats ?? stateVal?.searchStats ?? [];
            const progressCounts = action.payload.data.progressCounts ?? stateVal?.progressCounts ?? [];
            const searchesList = action.payload.data.searches ?? stateVal?.searches ?? [];

            return (state || Map()).set(action.payload.jobId, {
                progressCounts,
                searchStats,
                searches: searchesList
            });
        }
        case RequestSearchDelete: {
            const { search } = action.payload;
            const data = state.get(search.jobId);
            const jobSearches = data.searches.map((s) => (s.id === search.id ? { ...s, deleted: true } : s));
            const searchStats = data.searchStats.filter((s) => s.id !== search.id);
            return state.set(search.jobId, { searches: jobSearches, searchStats, progressCounts: data.progressCounts });
        }
        case ReceivePurgeCandidatesResponse: {
            if (state && state.has(action.payload.id)) {
                return state.remove(action.payload.id);
            } else {
                return state;
            }
        }
        default:
            return state;
    }
}
